module.exports = __webpack_public_path__ + "media/yelp-logo.d6efcc49e5e6df17ccab628a1a2a630b.svg";